<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">{{ title ? title : "Specialities" }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <div v-if="specialities && specialities.length >0" class="chip-list">
            <v-chip
              v-for="(speciality,i) in specialities"
              :key="i"
              class="text-capitalize cursor mr-2"
            >
              {{ speciality }}
            </v-chip>
          </div>
          <div v-if="insuranceName && insuranceName.length > 0" class="chip-list">
            <v-chip
              v-for="(name,i) in insuranceName"
              :key="i"
              class="text-capitalize cursor mr-2"
            >
              {{ name }}
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ["specialities","insuranceName","title"],
};
</script>
